
import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  GET_OPSGENIE_TEAMS,
  GET_REFRESH_OPSGENIE
} from "./actionTypes";

import {
  getOpsGenieTeamsSuccess, getOpsGenieTeamsFail, getOpsGenieRefreshSuccess, getOpsGenieRefreshFail
} from "./actions";

import {
  getOpsGenieTeamsUrl, getOpsgenieRefreshUrl
} from "../../helpers/fakebackend_helper";

function* onGetOpsGenieTeams() {
  try {
    const response = yield call(getOpsGenieTeamsUrl);
    yield put(getOpsGenieTeamsSuccess(response));
  } catch (error) {
    yield put(getOpsGenieTeamsFail(error.message));
  }
}
function* onGetOpsGenieRefresh() {
  try {
    const response = yield call(getOpsgenieRefreshUrl);
    yield put(getOpsGenieRefreshSuccess(response));
  } catch (error) {
    yield put(getOpsGenieRefreshFail(error.message));
  }
}

function* opsgenieTeamsSaga() {
  yield takeEvery(GET_OPSGENIE_TEAMS, onGetOpsGenieTeams);
  yield takeEvery(GET_REFRESH_OPSGENIE, onGetOpsGenieRefresh);
}

export default opsgenieTeamsSaga;
